import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subdomain } from 'src/app/model/enum/observations/subdomain.enum';
import { Domain } from 'src/app/model/enum/observations/domain.enum';
import { SubdomainLookup } from 'src/app/model/interfaces/SubdomainLookup.interface';
import { DomainNavigationData } from 'src/app/model/interfaces/DomainNavigationData.interface';
import { RubricResponse } from 'src/app/model/enum/rubric/rubric-response.enum';
import { StateService } from '@uirouter/core';
import { DomainFilterType } from 'src/app/model/enum/observations/domain-filter-type.enum';
import { ResourceData } from 'src/app/services/resource/resource.service';

@Component({
    selector: 'app-rubric-subdomain-summary',
    templateUrl: './rubric-subdomain-summary.component.html',
    styleUrls: ['./rubric-subdomain-summary.component.scss']
})
export class RubricSubdomainSummaryComponent implements OnInit, OnChanges {
    @Input() domain?: Domain;
    @Input() rubricComponent?: SubdomainLookup;
    @Input() currentRubricComponent?: Subdomain;
    @Input() domainNavigationData?: DomainNavigationData;
    @Input() resourceFile?: ResourceData = {};
    @Input() resourceFileKey?: string = '';

    @Input() readonly?: boolean = false;
    @Input() isFocusArea?: boolean = false;
    @Input() showFocusAreas?: boolean = false;

    @Input() showTeacherRating?: boolean = true;
    @Input() showEvaluatorRating?: boolean = true;

    teacherRubricResponse: RubricResponse = RubricResponse.UNSELECTED;
    evaluatorRubricResponse:RubricResponse = RubricResponse.UNSELECTED;

    constructor(private stateService: StateService) {}

    ngOnInit(): void {
        this.updateResponses(this.domain, this.rubricComponent?.Value, this.domainNavigationData);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const domainNavigationData = changes['domainNavigationData']?.currentValue;

        if (domainNavigationData !== undefined) {
            this.updateResponses(this.domain, this.rubricComponent?.Value, domainNavigationData);
        }
    }

    onClick = () => {
        this.stateService.go('.', { currentRubricComponent: this.rubricComponent?.Value, filterType: DomainFilterType.COMPONENT })
    }

    private updateResponses(domain?: Domain, subdomain?: Subdomain, domainNavigationData?: DomainNavigationData) {
        const domainData = (domainNavigationData ?? {}) [domain ?? ''] ?? {};
        const subdomainData = domainData[subdomain ?? ''] ?? {};
        this.teacherRubricResponse = this.showTeacherRating ? subdomainData.teacherResponse ?? RubricResponse.UNSELECTED : RubricResponse.UNSELECTED;
        this.evaluatorRubricResponse = this.showEvaluatorRating ? subdomainData.principalResponse ?? RubricResponse.UNSELECTED : RubricResponse.UNSELECTED;
    }

}
